import React, { useState } from "react";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';

const Date = (props) => {
    const { formInputsProps } = props;
    const [startDate, setStartDate] = useState(null);
    return (
        <div className="col-12 form-group">
            <label> {formInputsProps?.formField?.is_mandatory ? '*' : null} { formInputsProps?.formField?.input } </label>
            <div className={`custom-datepicker ${formInputsProps.responseData.theme}`}>
            <DatePicker
                selected = { startDate }
                className = 'calIcon'
                onChange = { date => setStartDate(date) }
                placeholderText = {'Select ' + formInputsProps?.formField?.input }
                dateFormat = { moment(new window.Date()).format(formInputsProps?.formField?.validation) }
                value = { formInputsProps.formValues[formInputsProps?.formField?.input] = startDate ? 
                            moment(new window.Date(startDate)).format(formInputsProps?.formField?.validation) 
                            : null
                        }
                 showTimeInput = {formInputsProps?.formField?.validation.includes('HH:mm') ? true : null } showYearDropdown showMonthDropdown dropdownMode="select"/>
            <i className="fa fa-calendar" aria-hidden="true"></i>
            </div>
            {
                formInputsProps.formValues[formInputsProps.formField?.input] && !formInputsProps.formErrors[formInputsProps.formField?.input] ? null : 
                <p className="errMsg">{formInputsProps.formErrors[formInputsProps.formField?.input]}</p>
            }    
        </div>
    )
}

export default Date